/* eslint-disable */
// Single source of truth for designer-name display handling across People.
//
// Rules per David (Phase 5 green-light notes):
//   1. Empty / whitespace-only names → filter out (return null)
//   2. "YAELI" and other all-caps variants → title-case for display
//   3. Mixed-case names (Adi, Noa, Noam) → unchanged
// Raw names (including "YAELI") are preserved for equality comparisons
// (e.g. filter rail → scorecard lookup). Display-case is for rendering only.

export function displayDesigner(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (s.length > 1 && s === s.toUpperCase()) {
    return s.charAt(0) + s.slice(1).toLowerCase();
  }
  return s;
}

export function isValidDesigner(raw) {
  return displayDesigner(raw) !== null;
}

// For "via {clicked_by}" in Ledger rows — shortens email to local-part and
// returns null when the clicked user is the same person as `actor` (any
// casing). Preserves the office-on-behalf-of pattern David flagged.
export function displayClickedBy(clickedBy, actor) {
  if (!clickedBy) return null;
  const local = String(clickedBy).split('@')[0].trim();
  if (!local) return null;
  const actorDisplay = displayDesigner(actor) || '';
  if (local.toLowerCase() === actorDisplay.toLowerCase()) return null;
  return local;
}
